'use client'

import { MoonIcon, SunIcon } from "@components/icons";
import { Switch } from "@nextui-org/react";
import { useLocalStore } from "@store/useLocalStore";

export function ThemeModeButton() {

    const { mode } = useLocalStore(state => state.theme);
    const { toggleThemeMode } = useLocalStore(state => state);
    const isSelected = mode === "dark" ? true : false;

    return (
        <div className="flex w-24 items-center justify-around">
            <SunIcon />
            <Switch
                isSelected={isSelected}
                size="sm"
                classNames={{ wrapper: `!m-0 ${isSelected ? "!bg-primaryBg" : "bg-mainBg"}` }}
                onChange={() => toggleThemeMode()}
            >
            </Switch>
            <MoonIcon />
        </div>
    )
}
